import React, {useState} from 'react';
import DialogComponent from '$components/DialogComponent';
import FrontdeskButton from '$components/FrontdeskButton';
import {formatFullName} from '$utils/helper';
import './CheckoutModal.scss';
import {useCheckInPatientHook} from '../hooks/useCheckInPatientHook';
import useAppointmentTimerSync from '../../../../hooks/useAppointmentTimerSync';

interface ConsultationOutcome {
  id: number;
  description: string;
  surgery_listed: boolean;
  follow_up_required: boolean;
}

interface CheckoutModalProps {
  open: boolean;
  handleClose: () => void;
  consultationOutcome: ConsultationOutcome;
  patientName: string;
  appointmentId: number;
  startTime: string;
}

const CheckoutModal: React.FC<CheckoutModalProps> = ({
  open,
  handleClose,
  consultationOutcome,
  patientName,
  appointmentId,
  startTime,
}) => {
  const [isPending, setIsPending] = useState(false);
  const {sendCheckInPatient} = useCheckInPatientHook();

  useAppointmentTimerSync(open ? appointmentId : undefined, data => {
    if (data) {
      setIsPending(false);
      handleClose();
    }
  });

  const handleConfirm = async () => {
    setIsPending(true);
    const payload = {
      appointmentId,
      check_out_time: new Date().toISOString(),
      check_in_time: startTime,
    };
    sendCheckInPatient(payload);
    setIsPending(false);
    handleClose();
  };

  return (
    <DialogComponent
      open={open}
      handleClose={handleClose}
      dialogBody={
        <div className="checkout-modal-body">
          <div className="checkout-modal-title">
            <div className="title-text">
              {`Do you want to check out ${formatFullName(patientName)}?`}
            </div>
            <div className="title-desc">
              Before proceeding, please review if the consultant has prescribed
              any additional actions.
            </div>
          </div>
          <div className="checkout-modal-outcome-section">
            {consultationOutcome?.surgery_listed && (
              <div className="checkout-modal-surgery-label">
                LIST PATIENT FOR SURGERY
              </div>
            )}
            {consultationOutcome?.follow_up_required && (
              <div className="checkout-modal-surgery-label">
                LIST PATIENT FOR FOLLOWUP
              </div>
            )}
          </div>

          <div className="checkout-modal-notes-label">Consultant's notes</div>
          <div className="checkout-modal-notes-box">
            {consultationOutcome?.description}
          </div>
          <div className="checkout-modal-footer">
            <FrontdeskButton
              title="Cancel"
              variant="danger"
              className="cancel-btn"
              onClick={handleClose}
            />
            <FrontdeskButton
              title={isPending ? 'Checking out...' : 'Confirm'}
              className="confirm-btn"
              loading={isPending}
              onClick={handleConfirm}
            />
          </div>
        </div>
      }
    />
  );
};

export default CheckoutModal;
